var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 540,
    height: 540,
    viewBox: "0 0 540 540",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M227.333 526C215.365 526 206 516.635 206 504.667C206 504.283 206.021 502.853 206.064 502.469L226.138 312.667H120.666C108.698 312.667 99.333 303.301 99.333 291.333C99.333 286.789 100.89 282.117 103.621 278.512L273.925 23.024C278.256 17.2 284.656 14 291.333 14C303.301 14 312.666 23.3653 312.666 35.3333C312.666 35.76 312.645 37.4453 312.602 37.872L292.656 206H419.333C431.301 206 440.666 215.365 440.666 227.333C440.666 231.835 439.109 236.507 436.4 240.133L244.634 517.147C240.41 522.8 234.01 526 227.333 526ZM291.397 35.3547L121.008 290.864L238 291.333C241.029 291.333 243.909 292.613 245.936 294.875C247.962 297.136 248.944 300.123 248.602 303.131L227.269 504.731L419.333 227.333C419.333 227.269 419.333 227.248 419.333 227.248L280.666 227.333C277.616 227.333 274.714 226.032 272.688 223.749C270.661 221.467 269.701 218.437 270.064 215.408L291.397 35.3547Z",
    fill: "#4C85B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlash);
export default __webpack_public_path__ + "static/media/flash.824bca00a177338d476d3cff000b7bf4.svg";
export { ForwardRef as ReactComponent };